/**
 * Created by bscholl on 10.02.17.
 */
import GenderSelection from './gender/GenderSelection';
import BirthdaySelection from './birthday/BirthdaySelection';
import AgeEstimation from './age/AgeEstimation';
import Results from './results/Results';
import LogUtil from '@/core/utils/logUtil';


export default class StepFactory {

    private _viewMap:any;
    private _data;

    constructor(data) {

        this._data = data;
        this._viewMap = {
            'gender_selection': GenderSelection,
            'birthday_selection': BirthdaySelection,
            'age_estimation': AgeEstimation,
            'results': Results
        };
    }

    getViewDataByID(id:string) {
        let copy = Object.assign({},this._data);
        copy = JSON.parse(JSON.stringify(copy));
        return copy;
    }

    getViewByID(type:string) {
        if(this._viewMap[type]) {

            return this._viewMap[type];
        }

        LogUtil.warn(`Step '${type}' not found.`);

        return null;
    }

    getViewInstanceById(id) {


        let ViewClass = this.getViewByID(id);


        if(!ViewClass) {
            return;
        }

        return new ViewClass(id, this.getViewDataByID(id));
    }
}
